import React, { useState, useEffect, Fragment } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { createTheme, ThemeProvider, StyledEngineProvider, adaptV4Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import {Typography, TextField, Divider, CircularProgress, Grid, Tooltip, Box,
IconButton, Button, Fab, MenuItem} from "@mui/material";
import LoginMenu from "../../../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import Autocomplete from '@mui/material/Autocomplete';
import BottomBar from "../../../../../components/BottomBar/BottomBar";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ImageIcon from '@mui/icons-material/Image';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import F111FormPopupComponent from "./F111FormPopupComponent";
import F111FormTableComponent from "./F111FormTableComponent";
import F111FormCardComponent from "./F111FormCardComponent";
import PostAddIcon from '@mui/icons-material/PostAdd';
import FilterIcon from "@mui/icons-material/FilterList";
import Collapse from '@mui/material/Collapse';

const useStyles = makeStyles((theme)=>createStyles({
  table: {
    minWidth: 750,
    width: '100%',
  },
  tableContainer: {
    //maxHeight: 440,
  },
  button: {
    margin: 0, //theme.spacing(1),
  },
  addTopicBtn: {
    float:"right",
    position:"fixed",
    zIndex:2,
    margin: theme.spacing(1),
    bottom: theme.spacing(0),
    right: theme.spacing(2),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const theme = createTheme(adaptV4Theme({
  palette: {
    primary: {
      main: '#174A84',
    }
  },
  overrides: {
    // Style sheet name
    MuiInputLabel:{
      // Name of the rule
      outlined: {
        // Some CSS
        transform: 'translate(40px, 20px) scale(1)'
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        '&&&[class*="MuiOutlinedInput-root"] $input:nth-of-type(1)': {
            paddingLeft: 35,
          },
        },
    },
    MuiSvgIcon: {
      colorPrimary: {
        color: '#174A84',
      },
    },
  },
}));

const R60Form = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { recordId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [showTableFilter, setShowTableFilter] = useState(true);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isDownloadPdf, setIsDownloadPdf] = useState(false);
  const [applicationStatusId, setApplicationStatusId] = useState(1);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [sectionsMenuItems, setSectionsMenuItems] = useState([]);
  const [sectionId, setSectionId] = useState(0);
  const [sectionIdError, setSectionIdError] = useState("");
  const [topicsMenuItems, setTopicsMenuItems] = useState([]);
  const [topicId, setTopicId] = useState({});
  const [topicIdError, setTopicIdError] = useState("");
  const [tableData, setTableData] = useState([]);
  const [popupBoxOpen, setPopupBoxOpen] = useState(false);
  const [isOnReplyForm, setIsOnReplyForm] = useState(false);

  const handleOpenSnackbar = (msg, severity) => {
    setIsOpenSnackbar(true);
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {  return; }
    setIsOpenSnackbar(false);
  };

  const handlePopupOpen = () => {
    setPopupBoxOpen(true);
  };

  const handlePopupClose = () => {
    setPopupBoxOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    // Note: page state not defined in original, keeping function for reference
  };

  const handleChangeRowsPerPage = (event) => {
    // Note: rowsPerPage and page state not defined in original, keeping function for reference
  };

  const getSections = async () => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C111CommonAcademicsStudentSectionsView`;
    await fetch(url, {
      method: "POST",
      headers: new Headers({Authorization:"Bearer "+localStorage.getItem("lmsToken")}),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setSectionsMenuItems(json.DATA || []);
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}<br/>{json.USER_MESSAGE}</span>,"error");
          }
          console.log("getSections", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(false);
          } else {
            //alert('Failed to fetch, Please try again later.');
            handleOpenSnackbar("Failed to fetch, Please try again later.","error");
            console.log(error);
          }
        }
      );
    setIsLoading(false);
  };

  const getTopics = async (sectionIdParam=0) => {
    setIsLoading(true);
    let data = new FormData();
    data.append("sectionId", sectionIdParam);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C111CommonAcademicsStudentSectionsForumsTopicView`;
    await fetch(url, {
      method: "POST",
      body:data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setTopicsMenuItems(json.DATA || []);
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}<br/>{json.USER_MESSAGE}</span>,"error");
          }
          console.log("getTopics", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(false);
          } else {
            //alert('Failed to fetch, Please try again later.');
            handleOpenSnackbar("Failed to fetch, Please try again later.","error");
            console.log(error);
          }
        }
      );
    setIsLoading(false);
  };

  const getData = async (sectionIdParam=0,topicIdParam=0) => {
    setIsLoading(true);
    let data = new FormData();
    data.append("sectionId", sectionIdParam);
    data.append("forumId", topicIdParam);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C111CommonAcademicsForumsView`;
    await fetch(url, {
      method: "POST",
      body:data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setTableData(json.DATA || []);
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}<br/>{json.USER_MESSAGE}</span>,"error");
          }
          console.log("getData", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            //alert('Failed to fetch, Please try again later.');
            handleOpenSnackbar("Failed to fetch, Please try again later.","error");
            console.log(error);
          }
        }
      );
    setIsLoading(false);
  };

  const handleSetSection = (value) => {
    let sectionIdValue = 0;
    if(value){
      sectionIdValue = value.id;
    }
    getTopics(sectionIdValue);
    getData(sectionIdValue,0);
    setTopicId({});
    setTopicIdError("");
    setSectionId(value);
    setSectionIdError("");
    setTableData([]);
  };

  const handleSetTopic = (value) => {
    setTopicId(value);
    setTopicIdError("");
    setTableData([]);
    let topicIdValue = 0;
    if(value){
      topicIdValue = value.id;
    }
    getData(sectionId,topicIdValue);
  };

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let regex = "";
    switch (name) {
      case "sectionId":
        getTopics(value);
        getData(value,0);
        setTopicId({});
        setTopicIdError("");
        setSectionId(value);
        setSectionIdError("");
        setTableData([]);
      break;
      default:
    }
    // Generic state updates for other fields
    if (name === "sectionId") {
      setSectionId(value);
      setSectionIdError("");
    }
  };

  const handleToggleTableFilter = () => {
    setShowTableFilter(!showTableFilter);
  };

  const handleReplyFormShow = (topicIdParam) => {
    setTopicId(topicIdParam);
    setIsOnReplyForm(true);
  };

  const handleReplyFormHide = () => {
    setIsOnReplyForm(false);
  };

  useEffect(() => {
    props.setDrawerOpen(false);
    getSections();
    // Parse recordId to number since useParams returns strings
    const recordIdNum = recordId ? parseInt(recordId, 10) : 0;
    if(recordIdNum && recordIdNum !== 0) {
      getTopics(recordIdNum);
      getData(recordIdNum,0);
      setSectionId(recordIdNum);
      setShowTableFilter(true);
    } else {
      getTopics(0);
      getData(0,0);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Fragment>
      <LoginMenu
        reload={isReload}
        open={isLoginMenu}
        handleClose={() => setIsLoginMenu(false)}
      />
      <div
        style={{
          padding: 20,
        }}
      >
        <Grid
          container
          justifyContent="space-between"
        >
          <F111FormPopupComponent
            handlePopupClose={handlePopupClose}
            popupBoxOpen={popupBoxOpen}
            handleOpenSnackbar={handleOpenSnackbar}
            getData={getData}
            sectionsMenuItems={sectionsMenuItems}
          />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {!isOnReplyForm && (
              <Tooltip title="Back to Home">
                <IconButton
                  onClick={() => navigate('/dashboard')}
                  style={{ marginRight: 10, color: "#1d5f98" }}
                  size="large"
                >
                  <ArrowBackIcon />
                </IconButton>
              </Tooltip>
            )}
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              {isOnReplyForm &&
                <Tooltip title="Back">
                  <IconButton
                    onClick={() => handleReplyFormHide()}
                    style={{
                      marginLeft: -15,
                      marginTop: -5,
                    }}
                    size="large">
                    <ArrowBackIcon color="primary" />
                  </IconButton>
                </Tooltip>
              }
              Message Center
            </Typography>
          </div>
          <span style={{
              float: "right",
              marginBottom: -6,
              marginTop: -12
          }}>
            {!isOnReplyForm &&
            <Fragment>
              <Tooltip title="Topic Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={handleToggleTableFilter}
                  size="large">
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
            </Tooltip>
            <Button
              variant="text"
              color="primary"
              className={classes.button}
              onClick={handlePopupOpen}
            >
              <PostAddIcon fontSize="default" color="primary"/>
              &nbsp;Add Topic
            </Button>
            </Fragment>
            }
          </span>
        </Grid>
        <Divider
          style={{
            backgroundColor: "rgb(58, 127, 187)",
            opacity: "0.3",
          }}
        />
        <br/>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
        >
          <Grid size={12}>
            {!isOnReplyForm && (
              <>
                <Collapse in={showTableFilter} timeout="auto" unmountOnExit>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <TextField
                        id="sectionId"
                        name="sectionId"
                        variant="outlined"
                        label="Section"
                        onChange={onHandleChange}
                        value={sectionId}
                        error={!!sectionIdError}
                        helperText={sectionIdError}
                        required
                        fullWidth
                        select
                        style={{marginTop:3}}
                      >
                        <MenuItem value={0}>All</MenuItem>
                        {sectionsMenuItems && !isLoading ? (
                          sectionsMenuItems.map((dt, i) => (
                            <MenuItem key={"sectionsMenuItems"+dt.id} value={dt.id}>
                              {dt.label}
                            </MenuItem>
                          ))
                        ) : (
                          <Grid container justifyContent="center">
                            <CircularProgress disableShrink />
                          </Grid>
                        )}
                      </TextField>
                        {/*
                        <Autocomplete
                          fullWidth
                          id="sectionId"
                          options={sectionsMenuItems}
                          value={sectionId}
                          onChange={(event, value) => handleSetSection(value)}
                          getOptionLabel={(option) => typeof option.label === 'string' ? option.label : ""}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Section"
                              placeholder="Search and Select"
                              error={!!sectionIdError}
                              helperText={sectionIdError ? sectionIdError : "" }
                            />
                          )}
                          style={{marginTop:4}}
                        />
                        */}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={theme}>
                          <Autocomplete
                            fullWidth
                            id="topicId"
                            options={topicsMenuItems}
                            value={topicId}
                            onChange={(event, value) => handleSetTopic(value)}
                            getOptionLabel={(option) => typeof option.label === 'string' ? option.label : ""}
                            renderInput={(params) => (
                              //console.log("params", params),
                              (<Fragment>
                                <SearchOutlinedIcon color="primary" style={{marginBottom:-45, paddingLeft:12}}/>
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  label="Topics"
                                  placeholder="Search and Select"
                                  error={!!topicIdError}
                                  helperText={topicIdError}
                                />
                              </Fragment>)
                            )}
                            style={{marginTop:"-1em"}}
                          />
                        </ThemeProvider>
                      </StyledEngineProvider>
                    </Grid>
                  </Grid>
                  <br/>
                </Collapse>
                <F111FormTableComponent
                  handleReplyFormShow={handleReplyFormShow}
                  rows={tableData}
                  isLoading={isLoading}
                />
              </>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 10, lg: 8, xl: 6 }}>
            {isOnReplyForm && (
              <F111FormCardComponent
                topicId={topicId}
                isOnReplyForm={isOnReplyForm}
                handleOpenSnackbar={handleOpenSnackbar}
                handlePopupClose={handlePopupClose}
              />
            )}
          </Grid>
          <Grid size={12}>
            {!isOnReplyForm && (
              <Fab
                variant="extended"
                size="small"
                color="primary"
                aria-label="add"
                className={classes.addTopicBtn}
                onClick={handlePopupOpen}
              >
                  <PostAddIcon className={classes.extendedIcon} />
                  Add Topic
              </Fab>
            )}
          </Grid>
        </Grid>
        <br/>
        {/*
        <BottomBar
          left_button_text="View"
          left_button_hide={true}
          bottomLeftButtonAction={viewReport}
          right_button_text="Genrate"
          bottomRightButtonAction={handleGenerate}
          loading={isLoading}
          isDrawerOpen={props.isDrawerOpen}
          disableRightButton={!monthId}
        />
        */}
        <CustomizedSnackbar
          isOpen={isOpenSnackbar}
          message={snackbarMessage}
          severity={snackbarSeverity}
          handleCloseSnackbar={() => handleCloseSnackbar()}
        />
      </div>
    </Fragment>
  );
};

export default R60Form;
